import Swal from "sweetalert2"
import { toast } from "react-toastify"
import { IConsultantMissionModel } from "@common-models/*"
import axios from "axios"
import {
     CONST_API_BUSINESS_CONSULTANT_CHECK_ASSURANCES_AS_NON_VERIFIED_ENDPOINT,
     CONST_API_BUSINESS_CONSULTANT_CHECK_ASSURANCES_AS_VERIFIED_ENDPOINT,
} from "../../../../../endpoints"

const useAssuranceListing = () => {
     function checkAssurancesAsVerified(
          missions: IConsultantMissionModel[],
          onConfirmCallback?: () => void,
          onSuccessCallback?: () => void,
          onDismissCallback?: () => void,
          onErrorCallback?: () => void
     ) {
          const ids = missions.map(item => item.id)

          Swal.fire({
               icon: "warning",
               title: `Veuillez confirmer votre action`,
               showCancelButton: true,
               confirmButtonText: "Confirmer",
               cancelButtonText: "Annuler",
               focusConfirm: true,
               showLoaderOnConfirm: true,
               preConfirm: async () => {
                    if (onConfirmCallback) onConfirmCallback()

                    return axios
                         .post(CONST_API_BUSINESS_CONSULTANT_CHECK_ASSURANCES_AS_VERIFIED_ENDPOINT, { mission_ids: ids })
                         .then(() => {
                              if (onSuccessCallback) onSuccessCallback()
                              toast.success("Votre action a bien été prise en compte", { autoClose: false })
                         })
                         .catch((e: any) => {
                              if (onErrorCallback) onErrorCallback()
                              toast.error(e?.response?.data?.detail, { autoClose: false })
                         })
               },
               allowOutsideClick: () => !Swal.isLoading(),
          }).then(result => {
               if (result.isDismissed && onDismissCallback) onDismissCallback()
          })
     }

     function checkAssurancesAsNonVerified(
          missions: IConsultantMissionModel[],
          onConfirmCallback?: () => void,
          onSuccessCallback?: () => void,
          onDismissCallback?: () => void,
          onErrorCallback?: () => void
     ) {
          const ids = missions.map(item => item.id)

          Swal.fire({
               icon: "warning",
               title: `Veuillez confirmer votre action`,
               showCancelButton: true,
               confirmButtonText: "Confirmer",
               cancelButtonText: "Annuler",
               focusConfirm: true,
               showLoaderOnConfirm: true,
               preConfirm: async () => {
                    if (onConfirmCallback) onConfirmCallback()

                    return axios
                         .post(CONST_API_BUSINESS_CONSULTANT_CHECK_ASSURANCES_AS_NON_VERIFIED_ENDPOINT, { mission_ids: ids })
                         .then(() => {
                              if (onSuccessCallback) onSuccessCallback()
                              toast.success("Votre action a bien été prise en compte", { autoClose: false })
                         })
                         .catch((e: any) => {
                              if (onErrorCallback) onErrorCallback()
                              toast.error(e?.response?.data?.detail, { autoClose: false })
                         })
               },
               allowOutsideClick: () => !Swal.isLoading(),
          }).then(result => {
               if (result.isDismissed && onDismissCallback) onDismissCallback()
          })
     }

     return { checkAssurancesAsVerified, checkAssurancesAsNonVerified }
}

export default useAssuranceListing
